import { t } from 'ttag'

import { appendSearchResults, initSearchResults } from './search'

import * as h2Api from '../h2Api'
import { generateClassName } from '../actions'

export const MAJOR_LOADED = 'MAJOR_LOADED'
export const CLEAR_SELECTION = 'MAJOR_CLEAR_SELECTION'
export const MAJOR_SELECT_LOADED = 'MAJOR_SELECT_LOADED'
export const MAJOR_LOADED_LOG = 'MAJOR_LOADED_LOG'
export const RATE_MAJOR = 'RATE_MAJOR'
export const LOCAL_LOADED = 'MAJOR_LOCAL_LOADED'
export const LOCAL_LOADING = 'MAJOR_LOCAL_LOADING'

export const ALL_MAJORS_LISTING = 'ALL_MAJORS_LISTING'

export const MAJOR_COMPARISON = 'MAJOR_COMPARISON'
export const MAJOR_COMPARISON_SET_ERROR = 'MAJOR_COMPARISON_SET_ERROR'
export const SELECT_MAJOR_FOR_COMPARISON = 'SELECT_MAJOR_FOR_COMPARISON'
export const REMOVE_MAJOR_FOR_COMPARISON = 'REMOVE_MAJOR_FOR_COMPARISON'
export const CLEAR_MAJOR_COMPARISON = 'CLEAR_MAJOR_COMPARISON'
export const ADD_ALL_MAJORS_LISTING = 'ADD_ALL_MAJORS_LISTING'

export const loadAllMajorsListing = form => dispatch => {
  const { types, ...filters } = form

  return dispatch(
    h2Api.post(`/programs/list`, { types, filters })({ type: ALL_MAJORS_LISTING })
  ).then(v => {
    console.log('APPENDING')
    dispatch(initSearchResults(v.results))

    return v
  })
}

export const loadSubsequentMajorsListing = filters => (startIdx, endIdx) => dispatch => {
  const updatedJson = {
    filters,
    start: startIdx,
    end: endIdx
  }

  return dispatch(
    h2Api.post(`/programs/list`, updatedJson)({ type: ADD_ALL_MAJORS_LISTING })
  ).then(v => {
    dispatch(appendSearchResults(v.results))
  })
}

export const selectMajorForComparison = id => (dispatch, getState) => {
  const comparisons = getState().college.comparison.selectedInstitutions.length

  if (comparisons == 4) {
    alert(t`You already have four items selected`)

    return false
  }

  return Promise.resolve(dispatch({ type: SELECT_MAJOR_FOR_COMPARISON, id }))
}

export const removeMajorForComparison = id => dispatch => {
  return Promise.resolve(dispatch({ type: REMOVE_MAJOR_FOR_COMPARISON, id }))
}

export const clearMajorComparison = () => dispatch => {
  return Promise.resolve(dispatch({ type: CLEAR_MAJOR_COMPARISON }))
}

export const compareMajors = cipCodes => dispatch => {
  const items = typeof cipCodes === 'string' ? [cipCodes] : cipCodes

  if (!items) {
    return Promise.resolve(
      dispatch({
        type: MAJOR_COMPARISON_SET_ERROR,
        error: t`No instructional programs specified for comparison`
      })
    )
  }

  dispatch({
    type: MAJOR_COMPARISON_SET_ERROR,
    error: null
  })

  return dispatch(
    h2Api.post('/programs/compare', { cipCode: items })({ type: MAJOR_COMPARISON })
  )
}

export const loadInstructionalProgram = cipCode => dispatch => {
  dispatch({ type: CLEAR_SELECTION })

  return dispatch(h2Api.get(`/programs/profile/${cipCode}`)({ type: MAJOR_LOADED }))
}

export const rateMajor = (cipCode, ratingType) => dispatch => {
  if (!dynamicValues.userProfile) {
    alert(t`You must be logged in to perform this action`)

    return
  }

  //console.log("RATING", occupation, ratingType)
  return dispatch(
    h2Api.put(`/user/rate/major/${cipCode}`, {
      rating: ratingType
    })({ type: RATE_MAJOR, id: generateClassName(cipCode) })
  )
}

export const selectLocalTab = (cipCode, tab) => dispatch => {
  dispatch({ type: LOCAL_LOADING })

  return dispatch(
    h2Api.get(`/programs/profile/${cipCode}/opportunities/${tab}`)({
      type: LOCAL_LOADED,
      selectedLocalTab: tab
    })
  )
}
